import { render } from "./AdminMonitorOscarPoolEventStreams.vue?vue&type=template&id=4c38de78&scoped=true"
import script from "./AdminMonitorOscarPoolEventStreams.vue?vue&type=script&lang=js"
export * from "./AdminMonitorOscarPoolEventStreams.vue?vue&type=script&lang=js"

import "./AdminMonitorOscarPoolEventStreams.vue?vue&type=style&index=0&id=4c38de78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c38de78"]])

export default __exports__